import React from "react";
import { MasterDetailLayout, Breadcrumb } from "../../components/Common";
import { useTenant } from "../../hooks/useTenant";
import useCrm from "./hooks/useCrm";
import CrmFilterBar from "./components/CrmFilterBar";
import CrmMemberList from "./components/CrmMemberList";

/**
 * CrmPage
 * Página de CRM — Gestão de Relacionamento com Clientes.
 * Layout MasterDetail: Sidebar de filtros (Col lg=3, md=4) + Tabela de resultados (Col lg=9, md=8).
 * A lista só exibe após clicar em "Buscar".
 */
const CrmPage = () => {
    document.title = "CRM | NeoApp";

    const { tenantSettings, tenantName, tenantLogo } = useTenant();

    const {
        members,
        loading,
        loadingRefs,
        hasSearched,
        filters,
        activeFilters,
        updateActiveFilter,
        updateFilter,
        resetFilters,
        executeSearch,
        memberships,
        activities,
        employees,
    } = useCrm();

    const handleSelectMember = (member) => {
        window.open(`/members/${member.id}`, "_blank");
    };

    return (
        <React.Fragment>
            <div className="d-flex align-items-center justify-content-between mb-3">
                <Breadcrumb title="CRM" />
            </div>

            <div className="border-top mb-3"></div>

            <div className="crm-container mt-3">
                <MasterDetailLayout
                master={
                    <CrmFilterBar
                        filters={filters}
                        activeFilters={activeFilters}
                        updateActiveFilter={updateActiveFilter}
                        updateFilter={updateFilter}
                        resetFilters={resetFilters}
                        onSearch={executeSearch}
                        memberships={memberships}
                        activities={activities}
                        employees={employees}
                        loading={loading}
                        loadingRefs={loadingRefs}
                    />
                }
                detail={
                    <div>
                        <CrmMemberList
                            members={members}
                            loading={loading}
                            hasSearched={hasSearched}
                            onSelectMember={handleSelectMember}
                            tenantName={tenantName || tenantSettings?.name}
                            tenantLogo={tenantLogo || tenantSettings?.logo}
                        />
                    </div>
                }
            />
            </div>
        </React.Fragment>
    );
};

export default CrmPage;

